export default __webpack_public_path__ + "static/media/224.c0d39546.jpg";